<template>
    <b-modal centered v-model="modal.show" :size="modal.size" :hide-header="modal.hideHeader" :hide-footer="modal.hideFooter">
        <component v-if="modal.component" :is="modal.component" :componentData="modal.data" />
    </b-modal>
    
</template>
<script>
import { InfoModal, PolygonPropertyModal, UnitScaleModal, ClientModal, DivaltoImport, MultiEquipmentEditModal, DivaltoCodeUpdate, DivaltoCodeCreate } from '@/components/modals'
import { mapGetters } from 'vuex'
export default {
    name: "ModalBasic", 
    components:{
        'info': InfoModal, 
        'polygon-property': PolygonPropertyModal, 
        'unit-scale': UnitScaleModal, 
        'client-new': ClientModal,
        'divalto-import': DivaltoImport,
        'multi-equipment-edit-modal': MultiEquipmentEditModal,
        'divalto-code-update': DivaltoCodeUpdate,
        'divalto-code-create': DivaltoCodeCreate

    },
    computed:{
        ...mapGetters({
            'modal' : 'ui/modal'
        })
    },
    data(){
        return {
            
        }
    }

}
</script>
<style>
    .modal-basic{
        background-color: linear-gradient(to right,#35b3ea,#0e89ce);
    }    
</style>
